import Error from '../components/Error';
import Layout from '../components/Layout';
import Loading from '../components/Loading';
import { useAuth } from '../context/AuthContext';
import "../styles/User.css"
import Orders from './Orders';

function User() {
    const { user, logout, error, isLoading } = useAuth();
    if (isLoading) return <Layout><Loading/></Layout>
    if (error) return <Error error={error} />
    return (
        <Layout>
            {/* <h2 style={{ margin: "0 10px", color: "var(--primary-color)" }}>Profile</h2> */}
            <br />
            <div className='user'>
                <img src={user.photo ? user.photo : "https://res.cloudinary.com/dgpznnv1r/image/upload/v1768841024/books/fzyjghqjqyrztxhlzya9.webp"} alt=""  height={120} />
                <br />
                <h3 style={{ color: "var(--primary-color)" }}>{user.name}</h3>
                <p style={{ color: "#555" }}>{user.email}</p>
                <br />
                <br />
                <button onClick={logout} className='btnLogout btn'>Logout</button>

            </div>
            <br /><br />
            {/* <h2 style={{ margin: "0 10px", color: "var(--primary-color)" }}>My Orders</h2> */}
            {/* <Orders></Orders> */}
        </Layout>

    )
}

export default User